
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftBottom50 as ObiThreewayAcuatorGenericInleftBottom50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-bottom-50.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftBottom50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-bottom-50',
   elementClass: ObiThreewayAcuatorGenericInleftBottom50Element,
   events: {
     
   }
  });
 
 